import { Button } from 'react-bootstrap';
import styles from './CompletedButton.module.scss';
import { showCheckmarkInCircleIcon } from '../../core/core';

const CompletedButton = ({ small, disabled, ...otherProps }) => (
  <div className={styles.completedButton}>
    <Button {...otherProps}>{showCheckmarkInCircleIcon()} Completed</Button>
  </div>
);

export default CompletedButton;
